<template>
  <tab-bar>
    <!-- <tab-bar-item></tab-bar-item> -->

    <tab-bar-item path="/controlpage/home">
      <!-- 路径别名的用法 -->
      <img
        slot="item-img"
        src="~assets/img/tabbar/changyong_changyong_1.png"
        alt
      />
      <img
        slot="item-img-active"
        src="~assets/img/tabbar/changyong_changyong.png"
        alt
      />
      <div slot="item-text">常用</div>
    </tab-bar-item>

    <tab-bar-item path="/controlpage/region">
      <img slot="item-img" src="~assets/img/tabbar/changyong_quyu_1.png" alt />
      <img
        slot="item-img-active"
        src="~assets/img/tabbar/changyong_quyu.png"
        alt
      />
      <div slot="item-text">区域</div>
    </tab-bar-item>

    <tab-bar-item path="/controlpage/message">
      <img slot="item-img" src="~assets/img/tabbar/changyong_xinxi_1.png" alt />
      <img
        slot="item-img-active"
        src="~assets/img/tabbar/changyong_xinxi.png"
        alt
      />
      <div slot="item-text">消息</div>
    </tab-bar-item>

    <!-- <tab-bar-item></tab-bar-item> -->
  </tab-bar>
</template>

<script>
import TabBar from 'components/common/tabbar/TabBar'
import TabBarItem from 'components/common/tabbar/TabBarItem'

export default {
  components: {
    TabBar,
    TabBarItem
  }
}
</script>

<style></style>
